import '../../css/GeneralCSS.css'
import '../../css/BaseElements/Buttons/Buttons.css'
import '../../css/Images.css'
import '../../css/Colors.css'
import '../../css/Text.css'
import 'bootstrap-icons/font/bootstrap-icons.css';

function SaveActivityButton( {onClick} ) {
    return (
      <button onClick={onClick} className={'saveActivityButton'}> Salva l'attività </button>
    );
  }
  export default SaveActivityButton;